/**
 * Shared navigation facts for the two Parent Landing CMS screens.
 *
 * They are two halves of one job — the Landing Page CMS owns the words and
 * pictures on /auth/parent-landing, the Assessment Question Bank owns the
 * papers behind its funnel — and an employee editing one routinely wants the
 * other. Both the cross-link and the "view the live page" link live here so the
 * two screens cannot drift apart on either.
 */

/**
 * The public page these screens edit.
 *
 * NOT `cms_page_meta.canonical_url`. That column is an SEO field an editor sets
 * for crawlers, so it can legitimately name the marketing host
 * (www.intervaledu.com) while the page an editor needs to open is served by the
 * student portal. Reading it back as a "View page" link sent employees to the
 * wrong site whenever the two differed.
 */
export const PUBLIC_LANDING_URL =
  process.env.REACT_APP_STUDENT_PORTAL_URL
    ? `${process.env.REACT_APP_STUDENT_PORTAL_URL.replace(/\/+$/, '')}/auth/parent-landing`
    : 'https://student.intervaledu.com/auth/parent-landing';

/**
 * Both screens are siblings under the same router (`my-workspace/*`), so
 * swapping the last path segment reaches the other one without hard-coding the
 * workspace prefix — the same idiom SkillxCommonBadges uses.
 */
export const CMS_ROUTES = {
  landing: 'landing-page-cms',
  questionBank: 'assessment-question-bank',
};

export const siblingPath = (pathname, slug) => pathname.replace(/[^/]+$/, slug);
